module.exports = {"geometryAttributes":[{"alias":"POO Latitude","domain":null,"editable":true,"length":9999,"name":"POOLatitude","nullable":false,"type":"latlong"},{"alias":"POO Longitude","domain":null,"editable":true,"length":9999,"name":"POOLongitude","nullable":false,"type":"latlong"},{"alias":"Initial Latitude","domain":null,"editable":true,"length":9999,"name":"InitialLatitude","nullable":false,"type":"latlong"},{"alias":"Initial Longitude","domain":null,"editable":true,"length":9999,"name":"InitialLongitude","nullable":false,"type":"latlong"}]}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/geometryAttributes.json
// module id = 1123
// module chunks = 0